__turbopack_context__.v({
  "black": "mochi-button-module-scss-module__ZabOlW__black",
  "blue": "mochi-button-module-scss-module__ZabOlW__blue",
  "button": "mochi-button-module-scss-module__ZabOlW__button",
  "dark": "mochi-button-module-scss-module__ZabOlW__dark",
  "dark-mode": "mochi-button-module-scss-module__ZabOlW__dark-mode",
  "full": "mochi-button-module-scss-module__ZabOlW__full",
  "grey": "mochi-button-module-scss-module__ZabOlW__grey",
  "icon-left": "mochi-button-module-scss-module__ZabOlW__icon-left",
  "icon-right": "mochi-button-module-scss-module__ZabOlW__icon-right",
  "large": "mochi-button-module-scss-module__ZabOlW__large",
  "light-mode": "mochi-button-module-scss-module__ZabOlW__light-mode",
  "loading": "mochi-button-module-scss-module__ZabOlW__loading",
  "loading-ellipse": "mochi-button-module-scss-module__ZabOlW__loading-ellipse",
  "loading-ellipse1": "mochi-button-module-scss-module__ZabOlW__loading-ellipse1",
  "loading-ellipse2": "mochi-button-module-scss-module__ZabOlW__loading-ellipse2",
  "loading-ellipse3": "mochi-button-module-scss-module__ZabOlW__loading-ellipse3",
  "normal": "mochi-button-module-scss-module__ZabOlW__normal",
  "outline": "mochi-button-module-scss-module__ZabOlW__outline",
  "outline-round": "mochi-button-module-scss-module__ZabOlW__outline-round",
  "primary": "mochi-button-module-scss-module__ZabOlW__primary",
  "primary2": "mochi-button-module-scss-module__ZabOlW__primary2",
  "secondary": "mochi-button-module-scss-module__ZabOlW__secondary",
  "small": "mochi-button-module-scss-module__ZabOlW__small",
  "solid": "mochi-button-module-scss-module__ZabOlW__solid",
  "solid-round": "mochi-button-module-scss-module__ZabOlW__solid-round",
  "text": "mochi-button-module-scss-module__ZabOlW__text",
  "text-button": "mochi-button-module-scss-module__ZabOlW__text-button",
  "text-simple": "mochi-button-module-scss-module__ZabOlW__text-simple",
  "tooltips": "mochi-button-module-scss-module__ZabOlW__tooltips",
  "with-icon": "mochi-button-module-scss-module__ZabOlW__with-icon",
});
